function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var PREVIEW_GIFT_REDEMPTION_ORDER = {
  BEGIN: 'PREVIEW_GIFT_REDEMPTION_ORDER_BEGIN',
  SUCCESS: 'PREVIEW_GIFT_REDEMPTION_ORDER_SUCCESS',
  FAILURE: 'PREVIEW_GIFT_REDEMPTION_ORDER_FAILURE'
};
export var UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE = {
  BEGIN: 'UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE_BEGIN',
  SUCCESS: 'UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE_SUCCESS',
  FAILURE: 'UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE_FAILURE'
};
export var SUBMIT_GIFT_ORDER_REDEMPTION_ORDER = {
  BEGIN: 'SUBMIT_GIFT_ORDER_REDEMPTION_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_GIFT_ORDER_REDEMPTION_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_GIFT_ORDER_REDEMPTION_ORDER_FAILURE'
};
export var RESET_REDEEM_GIFT_ORDER = 'RESET_REDEEM_GIFT_ORDER';
export var UPDATE_REDEMPTION_CODE = 'UPDATE_REDEMPTION_CODE';
export var UPDATE_GIFT_ORDER_SHIPPING_ADDRESS = 'UPDATE_GIFT_ORDER_SHIPPING_ADDRESS';
export var UPDATE_GIFT_ORDER_SHIP_TO_NAME = 'UPDATE_GIFT_ORDER_SHIP_TO_NAME';
var PREVIEW_GIFT_REDEMPTION_ORDER_TYPES = [PREVIEW_GIFT_REDEMPTION_ORDER.BEGIN, PREVIEW_GIFT_REDEMPTION_ORDER.SUCCESS, PREVIEW_GIFT_REDEMPTION_ORDER.FAILURE];
var UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE_TYPES = [UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE.BEGIN, UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE.SUCCESS, UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE.FAILURE];
var SUBMIT_GIFT_ORDER_REDEMPTION_ORDER_TYPES = [SUBMIT_GIFT_ORDER_REDEMPTION_ORDER.BEGIN, SUBMIT_GIFT_ORDER_REDEMPTION_ORDER.SUCCESS, SUBMIT_GIFT_ORDER_REDEMPTION_ORDER.FAILURE];
var updatePreviewWithSubscriptionsQuotePromise = function updatePreviewWithSubscriptionsQuotePromise(dispatch, redemptionCode, paymentInstrumentId, customerId) {
  var requestData = {
    RedemptionCode: redemptionCode
  };
  if (paymentInstrumentId) {
    requestData.ReturnSubscriptionPreviews = true;
    requestData.PaymentInstrumentIds = [paymentInstrumentId];
  }
  var customHeaders = {};
  if (customerId) {
    customHeaders = _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId);
  }
  return ThunkHelper(dispatch, UPDATE_PREVIEW_WITH_SUBSCRIPTIONS_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/PreviewGiftRedemptionOrder',
    data: requestData,
    headers: customHeaders
  });
};
var fetchGiftOrderPreviewPromise = function fetchGiftOrderPreviewPromise(dispatch, redemptionCode, paymentInstrumentId, customerId) {
  var requestData = {
    RedemptionCode: redemptionCode
  };
  if (paymentInstrumentId) {
    requestData.ReturnSubscriptionPreviews = true;
    requestData.PaymentInstrumentIds = [paymentInstrumentId];
  }
  var customHeaders = {};
  if (customerId) {
    customHeaders = _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId);
  }
  return ThunkHelper(dispatch, PREVIEW_GIFT_REDEMPTION_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/PreviewGiftRedemptionOrder',
    data: requestData,
    headers: customHeaders
  });
};
export var updatePreviewWithSubscriptionsQuote = function updatePreviewWithSubscriptionsQuote(redemptionCode, paymentInstrumentId, customerId) {
  return function (dispatch) {
    return updatePreviewWithSubscriptionsQuotePromise(dispatch, redemptionCode, paymentInstrumentId, customerId);
  };
};
export var fetchGiftOrderPreview = function fetchGiftOrderPreview(redemptionCode) {
  return function (dispatch) {
    return fetchGiftOrderPreviewPromise(dispatch, redemptionCode, null, null);
  };
};
var submitRedeemGiftOrderPromise = function submitRedeemGiftOrderPromise(dispatch, redemptionCode, customerId, paymentInstrumentId, shippingAddress, shippingMethodId, shipToName) {
  var requestData = {
    RedemptionCode: redemptionCode
  };
  if (paymentInstrumentId) {
    requestData.PaymentInstrumentIds = [paymentInstrumentId];
  }
  if (shippingAddress) {
    requestData.ShippingAddress = shippingAddress;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = shipToName;
    requestData.RecordPaymentInformation = false;
  }
  return ThunkHelper(dispatch, SUBMIT_GIFT_ORDER_REDEMPTION_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitGiftRedemptionOrder',
    data: requestData,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var submitRedeemGiftOrder = function submitRedeemGiftOrder(_ref) {
  var customerId = _ref.customerId,
    redemptionCode = _ref.redemptionCode,
    _ref$shippingAddress = _ref.shippingAddress,
    shippingAddress = _ref$shippingAddress === void 0 ? null : _ref$shippingAddress,
    _ref$shippingMethodId = _ref.shippingMethodId,
    shippingMethodId = _ref$shippingMethodId === void 0 ? null : _ref$shippingMethodId,
    _ref$shipToName = _ref.shipToName,
    shipToName = _ref$shipToName === void 0 ? null : _ref$shipToName,
    _ref$paymentInstrumen = _ref.paymentInstrumentId,
    paymentInstrumentId = _ref$paymentInstrumen === void 0 ? null : _ref$paymentInstrumen;
  return function (dispatch) {
    return submitRedeemGiftOrderPromise(dispatch, redemptionCode, customerId, paymentInstrumentId, shippingAddress, shippingMethodId, shipToName);
  };
};
export var resetRedeemGiftOrder = function resetRedeemGiftOrder() {
  return {
    type: RESET_REDEEM_GIFT_ORDER
  };
};
export var updateGiftOrderRedemptionCode = function updateGiftOrderRedemptionCode(redemptionCode) {
  return {
    type: UPDATE_REDEMPTION_CODE,
    payload: redemptionCode
  };
};
export var updateGiftOrderSelectedShippingAddress = function updateGiftOrderSelectedShippingAddress(shippingAddress) {
  return {
    type: UPDATE_GIFT_ORDER_SHIPPING_ADDRESS,
    payload: shippingAddress
  };
};
export var updateGiftOrderShipToName = function updateGiftOrderShipToName(shipToName) {
  return {
    type: UPDATE_GIFT_ORDER_SHIP_TO_NAME,
    payload: shipToName
  };
};
export var SET_SELECTED_SHIPPING_METHOD = 'SET_SELECTED_SHIPPING_METHOD';
export var setSelectedShippingMethod = function setSelectedShippingMethod(shippingMethod) {
  return {
    type: SET_SELECTED_SHIPPING_METHOD,
    payload: shippingMethod
  };
};